import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PaymentModel} from '@app/models/payment';
import PaymentStatus = PaymentModel.PaymentStatus;

@Component({
    selector: 'app-tag-payment-status',
    template: `
        <ng-container *ngIf="value">
            <p-tag [value]="value" [severity]="severity"></p-tag>
        </ng-container>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagPaymentStatusComponent implements OnChanges {
    @Input() value: PaymentStatus;

    severity: string;

    ngOnChanges(changes: SimpleChanges): void {
        if (this.value) {
            switch (this.value) {
                case 'PENDING':
                    this.severity = 'info';
                    break;
                case 'PAID':
                    this.severity = 'success';
                    break;
                case 'REFUND':
                    this.severity = 'warning';
                    break;
                case 'FAIL':
                    this.severity = 'danger';
                    break;
                case 'EXPIRED':
                    this.severity = 'danger';
                    break;
                default:
                    this.severity = 'info';
                    break;
            }
        }
    }
}
